import { requestBaseService } from './index'

export const getPromotion = () => {
  return requestBaseService({
    url: `console/ex/v1/popup-promotion`,
    // url: `/promotion-pop-up/pop-up`,
    method: 'get',
  })
}

export const getPromotionDetail = (payload) => {
  return requestBaseService({
    url: `promotion/${payload.id}`,
    method: 'get',
  })
}

const Promotion = {
  getPromotion,
  getPromotionDetail
}

export default Promotion
